module.exports = __webpack_public_path__ + "img/logo.207d10c0.png";